import { Box, Typography } from "@mui/material";
import EntityTable from "../../../../common/Tables/EntityTable";
import ReservationCreator from "./ReservationCreator/ReservationCreator";
import ReservationStatus from "./ReservationStatus";
import { dateUtils } from "../../../../utils/DateUtils";

const DateCell = ({ date }) => {
    const dayOfWeek = date.toLocaleString('en-uk', { weekday: 'short' });
    const time = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });

    return <Box>
        <Typography sx={{ fontSize: 14 }}>{dateUtils.getFormattedDate(date)}</Typography>
        <Typography sx={{ fontSize: 12 }}>{dayOfWeek} {time}</Typography>
    </Box>
}

const ReservationsList = ({ reservations, rooms, onReservationSelect, onCreateReservation, onUpdateReservation }) => {
    const gridColumns = [
        {
            field: 'confirmationNumber',
            headerName: 'Confirmation #',
            minWidth: 130,
            sortable: false,
        },
        {
            field: 'creationTime',
            headerName: 'Created on',
            minWidth: 100,
            renderCell: (params) => {
                return <DateCell date={params.row.creationTime} />
            }
        },    
        {
            field: 'status',
            headerName: 'Status',
            sortable: false,
            minWidth: 120,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return <ReservationStatus status={params.row.status} />
            }
        },
        {
            field: 'guest',
            headerName: 'Customer',
            valueGetter: (params) => `${params.row.firstName} ${params.row.lastName}`,
            minWidth: 200,
            sortable: false,
        },
        {
            field: 'checkin',
            headerName: 'Check in',
            minWidth: 100,
            renderCell: (params) => {
                return <DateCell date={params.row.checkin} />
            }
        },
        {
            field: 'checkout',
            headerName: 'Check out',
            minWidth: 100,
            renderCell: (params) => {
                return <DateCell date={params.row.checkout} />
            }
        },
        {
            field: 'los',
            headerName: 'Nights',
            width: 70,
            align: 'center',
            headerAlign: 'center',
            valueGetter: (params) => dateUtils.getLengthOfStay(params.row.checkin, params.row.checkout),
            sortable: false,
        },
        {
            field: 'room',
            headerName: 'Room',
            minWidth: 200,
            valueGetter: (params) => `${rooms.filter(room => room.id === params.row.roomId)[0].name}`,
            sortable: false,
        },
        {
            field: 'totalPrice',
            headerName: 'Total Price',
            align: 'right',
            minWidth: 120,
            valueGetter: (params) => `${params.value} PLN`,
        },
        {
            field: 'comments',
            headerName: 'Comments',
            flex: 2,
            sortable: false,
        },
    ];

    return <EntityTable
        data={reservations}
        columns={gridColumns}
        enableCreateEntity
        onCellClick={onReservationSelect}
        EditorComponent={ReservationCreator}
        onEntityCreateSuccess={onCreateReservation}
        onEntityUpdateSuccess={onUpdateReservation}
        noEntitiesMessage="It looks like you haven't got any reservations yet"
        dataGridProps={{
            initialState: {
                sorting: {
                    sortModel: [{ field: 'id', sort: 'desc' }],
                },
            }
        }}
    />
}

export default ReservationsList;